module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1008.9318200e.png";